// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__EOdw5","box":"WorkspacesBox_box__3fgcn","node":"WorkspacesBox_node__1Q_nu"};